// extracted by mini-css-extract-plugin
export default {"cancel_page_wrapper":"a","cancel_page":"b","title":"c"};
    if(module.hot) {
      // 1711394573762
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  